import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Store} from '../../../store';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ConstantsService} from '../../../core/services/constants.service';
import {FormArray, UntypedFormGroup} from '@angular/forms';
import * as _ from 'underscore';
import {isNil} from 'lodash-es';
import  {upperFirst} from 'lodash-es';
import {InstrumentItem} from '../../../core/models/InstrumentItem';

@Component({
    selector: 'app-model-instrument',
    templateUrl: './model-instrument.component.html',
    styleUrls: ['./model-instrument.component.scss'],
    standalone: false
})
export class ModelInstrumentComponent implements OnInit {
    @Input()
    instrumentItemFormGroup: UntypedFormGroup;

    @Input()
    mode: string;

    @Input()
    index: number;

    @Output()
    removeInstrument = new EventEmitter();

    @Output()
    resetFormGroup = new EventEmitter<string>();

    modelPopupMode: any;
    selectedInstrument: any;
    instrumentConfigs: any[];
    formReset = false;
    counterParties = [];
    disableSpread: any;
    disableRefForward: any;
    disableCoupon: any;
    instrument: InstrumentItem;
    columnConfig: any[];

    /*get counterPartyTradeValues() {
        return this.instrumentItemFormGroup.get('counterPartyTradeValues') as FormArray;
    }*/

    constructor(public activeModal: NgbActiveModal, private constantsService: ConstantsService) {
    }

    ngOnInit() {
        this.modelPopupMode = this.constantsService.modelPopupMode;
        this.instrumentConfigs = this.constantsService.instrumentConfigs;
        this.instrument = this.instrumentItemFormGroup.value;
        if (this.instrument.modelId && this.instrument.modelId !== '') {
            this.selectedInstrument = _.find(this.instrumentConfigs, x => x.instrument === this.instrument.instrType);
            this.columnConfig = this.computeColumnConfig(this.selectedInstrument.columns);
        } else {
            this.selectedInstrument = null;
        }
        this.disableLegTypeRelatedFields();
    }

    onRemoveInstrument() {
        this.removeInstrument.emit();
    }

    disableLegTypeRelatedFields() {
        setTimeout(() => {
            this.onLegTypeChange({
                leg: 'leg1',
                value: this.instrumentItemFormGroup.controls['leg1LegType'].value
            });
        }, 0);
        setTimeout(() => {
            this.onLegTypeChange({
                leg: 'leg2',
                value: this.instrumentItemFormGroup.controls['leg2LegType'].value
            });
        }, 0);
    }

    onLegTypeChange(newValue) {
        if (this.mode != this.modelPopupMode.view) {
            const leg = newValue.leg;
            const trueObj = { leg: leg, value: true };
            const falseObj = { leg: leg, value: false };
            if (newValue.value === '0') {
                this.disableSpread = trueObj;
                this.disableRefForward = trueObj;
                this.disableCoupon = falseObj;
            } else if (newValue.value === '1') {
                this.disableSpread = falseObj;
                this.disableRefForward = falseObj;
                this.disableCoupon = trueObj;
            } else {
                this.disableSpread = falseObj;
                this.disableRefForward = falseObj;
                this.disableCoupon = falseObj;
            }
        }
    }

    onIntrumentChange(newValue) {
        this.instrumentItemFormGroup.reset();
        _.each(this.instrumentItemFormGroup.controls, control => {
            control.clearValidators();
            control.enable();
        });

        this.formReset = true;
        setTimeout(() => {
            this.formReset = false;
        }, 0);
        if (this.instrumentItemFormGroup.controls.instrType) {
            this.instrumentItemFormGroup.controls.instrType.setValue(newValue?newValue.instrument:'');
        }
        this.columnConfig = this.computeColumnConfig(this.selectedInstrument ? this.selectedInstrument.columns : {});

    }

    isDisabled(name: string) {
        let ret = true;
        const activated = [
            'Cash',
            'Fixed Bond',
            'Floater',
            'IRS',
            'Bond Forward',
            'CCS',
            // 'CMS',
            'FXFwd',
            'FXSwp',
            'Repo',
            //'Equity Option',
            //'FX Option',
            'Bond Future',
            'Bond Forward',
        ];
        if (activated.indexOf(name) !== -1) {
            ret = false;
        }
        return ret;
    }

    computeFieldTemplateType(name) {
        const stdTypeCols = [
            'id', 'issueDate', 'maturityDate', 'notional', 'payNotional', 'bondNotional',
            'fxRate', 'repoRate', 'irsNotional', 'currency', 'fixedRateCoupon', 'couponFrequency', 'bondIssueDate',
            'bondMaturityDate', 'bondPrice', 'disCurve', 'npvUsd', 'bondCurrency', 'againstCurrency',
            'haircutAfterPricing', 'principalExchanged'
        ];
        const accountingTypeCols = ['pnlAccounting', 'priceAccounting'];
        if (stdTypeCols.indexOf(name) !== -1) {
            return 'standard';
        }
        if (accountingTypeCols.indexOf(name) !== -1) {
            return 'accounting';
        }
        return name;
    }

    computeColumnConfig(def: any): any[]{
        const cols = [];
        for (const field in def) {
            if (def.hasOwnProperty(field)) {
                if (def[field]['enable']) {
                    cols.push({
                        ...def[field],
                        ['name']: field,
                        ['controlName']: upperFirst(field),
                        ['controlType']: this.computeFieldTemplateType(field)
                    });
                }
            }
        }
        cols.sort((a, b) => a.columnIndex - b.columnIndex);
        return cols;
    }
}
